"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = exports.TextArea = exports.Select = exports.Input = exports.FieldContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FieldContainer = _styledComponents.default.div`
  margin-bottom: 10px;
  .label {
    font-weight: bold;
  }
  .error {
    color: #ff0000;
  }
`;
exports.FieldContainer = FieldContainer;
const Input = _styledComponents.default.input`
  margin: 5px 5px 4px 0;
  padding: 5px;
`;
exports.Input = Input;
const Select = _styledComponents.default.select`
  margin: 5px 5px 4px 0;
  padding: 5px;
  min-width: 190px;
`;
exports.Select = Select;
const TextArea = _styledComponents.default.textarea`
  padding: 5px;
  min-width: 180px;
  height: 75px;
`;
exports.TextArea = TextArea;
const Label = _styledComponents.default.label`
  margin-right: 20px;
`;
exports.Label = Label;